import EmbeddedProduct from '../images/EmbeddedProduct.svg';
import EmbeddedSoftware from '../images/EmbeddedSoftware.svg';
import ApplicationSoftware from '../images/ApplicationSoftware.svg';
import PrototypingVolume from '../images/PrototypingVolume.svg';
import Star from '../images/Star.svg'; 
import StarM from '../images/StarM.svg';

const CoreServices = () => {
    return (
        <>
             <div className='flex flex-col items-center mx-4 sm:mx-12 py-14 sm:pt-28 sm:pb-8 xl:pb-10'>
                <h1 className='text-[var(--kaizekblue)] font-uiBold text-4xl xl:text-5xl'>Core Services</h1>
                <p className='text-[var(--lightgray)] font-symbol text-xl lg:text-2xl text-center my-4'>End-to-end embedded systems and IoT solutions</p>
                
                <div className='sm:relative grid sm:grid-cols-2 gap-2 sm:gap-0 mt-8 lg:mt-16 2xl:w-9/12'>
                    <div className='p-8 xl:px-10 xl:py-12 2xl:px-12 2xl:py-16'>
                        <img src={EmbeddedProduct} alt=""></img>
                        <h2 className="text-[var(--kaizekblue)] font-uiBold text-2xl lg:text-[1.75rem] 2xl:text-3xl my-2 sm:my-4 lg:my-8 sm:w-8/12 xl:w-full">Embedded Product Design</h2>
                        <ul className="text-[var(--lightgray)] font-symbol text-base lg:text-xl ps-2 lg:ps-8 list-disc list-outside lg:space-y-2 my-4">
                            <li><strong>Embedded Solutions</strong> - Embedded hardware and software for Industrial & IoT products.</li>
                            <li><strong>PCB Design</strong> - Design & development of high-speed digital and mixed-signal PCBs.</li>
                            <li><strong>Advanced Development</strong> - Complex hardware and software development.</li>
                        </ul>
                        <div className='sm:hidden w-full pt-4'>
                            <img src={StarM} alt='Star-Mobile'></img>
                        </div>
                    </div>
                    <div className='p-8 xl:px-10 xl:py-12 2xl:px-12 2xl:py-16'>
                        <img src={EmbeddedSoftware} alt=""></img>
                        <h2 className="text-[var(--kaizekblue)] font-uiBold text-2xl lg:text-[1.75rem] 2xl:text-3xl my-2 sm:my-4 lg:my-8">Embedded Software Development</h2>
                        <ul className="text-[var(--lightgray)] font-symbol text-base lg:text-xl ps-2 lg:ps-8 list-disc list-outside lg:space-y-2 my-4">
                            <li><strong>Firmware Development</strong> - MCU programming, RTOS, sensors, and power management.</li>
                            <li><strong>BSP & Middleware</strong> - LoRa, LTE, Wi-Fi, BLE, industrial protocols, OTA, and cloud connectivity.</li>
                            <li><strong>Linux Development</strong> - Driver, bootloader, porting, and optimization.</li>
                        </ul>
                        <div className='sm:hidden w-full pt-4 flex items-center justify-center'>
                            <img src={StarM} alt='Star-Mobile'></img>
                        </div>
                    </div>
                    <div className='p-8 xl:px-10 xl:py-12 2xl:px-12'>
                        <img src={ApplicationSoftware} alt="" className='lg:mt-8'></img>
                        <h2 className="text-[var(--kaizekblue)] font-uiBold text-2xl lg:text-[1.75rem] 2xl:text-3xl my-2 sm:my-4 lg:my-8">Application Software Development</h2>
                        <ul className="text-[var(--lightgray)] font-symbol text-base lg:text-xl ps-2 lg:ps-8 list-disc list-outside lg:space-y-2 my-4">
                            <li><strong>End-User Applications</strong> - Java, Python, C#/.Net, and Qt/Linux application development.</li>
                            <li><strong>Mobile Applications</strong> - Android development, iOS development, and QA testing for mobile & web portals.</li>
                            <li><strong>Cloud software & Web applications</strong> - IoT solutions, Cloud, device management, and dashboards.</li>
                        </ul>
                        <div className='sm:hidden w-full pt-4'>
                            <img src={StarM} alt='Star-Mobile'></img>
                        </div>
                    </div>
                    <div className='p-8 xl:px-10 xl:py-12 2xl:px-12'>
                        <img src={PrototypingVolume} alt="" className='lg:mt-8'></img>
                        <h2 className="text-[var(--kaizekblue)] font-uiBold text-2xl lg:text-[1.75rem] 2xl:text-3xl my-2 sm:my-4 lg:my-8">Prototyping & Volume Manufacturing</h2>
                        <ul className="text-[var(--lightgray)] font-symbol text-base lg:text-xl ps-2 lg:ps-8 list-disc list-outside lg:space-y-2 my-4">
                            <li><strong>End-to-End Development</strong> - Turnkey solutions from concept to mass production, including sourcing.</li>
                            <li><strong>Fast Deployment</strong> - Agile development to accelerate time to market.</li>
                            <li><strong>Robust Engineering</strong> - Reliable designs tailored for real-world conditions.</li>
                        </ul>
                        <div className='sm:hidden w-full pt-4'>
                            <img src={StarM} alt='Star-Mobile'></img>
                        </div>
                    </div>
                    <div className='hidden absolute inset-0 sm:flex justify-center items-center pointer-events-none'>
                        <img src={Star} alt='star' className="w-auto h-auto sm:-mt-8 lg:-mt-9 xl:-mt-1 2xl:mt-0"></img>
                    </div>
                </div>
                
            </div>
        </>
    )
}
export default CoreServices